/*
  NAVEE 定制：卖点卡片的 Show more / Show less 开关。
  事件委托挂在 document 上，所以主题编辑器里重新渲染 section 也不用重新初始化。
  卡片的显示/隐藏和开关卡的位置都由 .is-expanded 在 CSS 里控制。
*/
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-selling-points-toggle]');
    if (!button) return;

    var group = button.closest('.selling-points');
    if (!group) return;

    var expanded = group.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
})();
